module.exports = __webpack_public_path__ + "img/site.6e23545a.png";